import type { TtsPlayer } from "./ttsPlayer";

// Barge-in (continuous conversation): VAD の onSpeechStart で TTS 再生中なら即停止。
// (spec: docs/superpowers/specs/2026-07-07-m3-continuous-conversation-requirements.md §3.3.1 / §4.1 Q3)
// VadController は onSpeechStart を constructor で受け取るが、bargein は独立した concern
// なので薄い bridge に切り出す (テスト容易性 + hooks 側からの取り外し容易さ)。
type VadRegistrar = { register: (cb: () => void) => void };

export class BargeInBridge {
  private tts: TtsPlayer | null = null;

  attach(tts: TtsPlayer, vad: VadRegistrar): void {
    this.tts = tts;
    vad.register(() => {
      if (this.tts?.isPlaying()) {
        this.tts.stop();
      }
    });
  }

  detach(): void {
    this.tts = null;
  }
}

// R3.3.2 short-utterance recovery: 発話が < 500ms (16kHz なら 8000 samples 未満) は
// STT を skip して recovery route (「うまく聞き取れませんでした」) に投げる。
// 実装は useContinuousMode の onSpeechEnd 側 (Task 15)。
export const SHORT_UTTERANCE_SAMPLES_16K = 8000;
